// extracted by mini-css-extract-plugin
export var bold = "table-module--bold--qXOgB";
export var table = "table-module--table--hDOuL";